import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <div className="footer-logo">
            <span className="logo-icon">🎯</span>
            <span className="logo-text">XPunters</span>
          </div>
          <p className="footer-description">
            The ultimate platform for sharing bet codes, competing in predictions,
            and winning real rewards.
          </p>
          <div className="footer-social">
            <a href="#" className="social-link" aria-label="Twitter">
              <i>🐦</i>
            </a>
            <a href="#" className="social-link" aria-label="Telegram">
              <i>✈️</i>
            </a>
            <a href="#" className="social-link" aria-label="Discord">
              <i>💬</i>
            </a>
          </div>
        </div>

        <div className="footer-section">
          <h4>Platform</h4>
          <ul>
            <li><Link to="/bet-codes">Bet Codes</Link></li>
            <li><Link to="/competitions">Competitions</Link></li>
            <li><Link to="/h2h">H2H Games</Link></li>
            <li><Link to="/rollover">Rollover</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Community</h4>
          <ul>
            <li><Link to="/leaderboard">Leaderboard</Link></li>
            <li><Link to="/explore">Explore Creators</Link></li>
            <li><Link to="/referral">Referral Program</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Support</h4>
          <ul>
            <li><a href="#">Help Center</a></li>
            <li><Link  to="/terms">Terms of Service</Link></li>
            <li><Link  to="/privacy">Privacy Policy</Link></li>
            <li><Link  to="/contact">Contact Us</Link></li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; {currentYear} XPunters. All rights reserved.</p>
        <p className="footer-version">v1.0.0</p>
      </div>
    </footer>
  );
};

export default Footer;